import { render, staticRenderFns } from "./consultant-documents.vue?vue&type=template&id=420e1302&scoped=true"
import script from "./consultant-documents.vue?vue&type=script&lang=js"
export * from "./consultant-documents.vue?vue&type=script&lang=js"
import style0 from "./consultant-documents.vue?vue&type=style&index=0&id=420e1302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420e1302",
  null
  
)

export default component.exports